import Vue from 'vue';
import Vuex from 'vuex';

import userState from '@/store/user/state.user';
import freeClinicState from '@/store/user/state.freeClinic';
import expertState from '@/store/expert/state.expert';
import nimState from '@/store/nim/state.nim';


import * as getters from './getters';
import * as actions from './actions';
import mutations from './mutations';
import nimMutations from './nim/mutations';


Vue.use(Vuex);

const state = Object.assign({
  isLoading: false, // ajax 请求状态
  firstAjaxStatus: 0, // 第一次ajax message请求完成状态
  connectStatus: 0, // socket 链接状态
  socket: null, // socket 实例
  reconnectErrorCount: 0, // 重连失败次数
  sendMessages: {}, // 已发送消息
  firstMessage: null, // 最老消息
  latestMessage: null, // 最新消息
  latestMessageTime: null, // 最新消息发送时间
  courseCloseState: -1, // 课程关闭状态，0 提示关闭， 1 已关闭
  messages: [], // 消息列表
  audioList: [], // 从消息列表过滤出来的audio
  lastPlayAudio: null, // 上一条播放的消息???!!!!!  明明是当前播放的语音
  messageStore: [], // 本地消息队列，用于控制消息有序渲染
  isLookHistoryMessage: 0, // 是否在查看历史消息，用于判断是否应该控制消息总数
  courseList: {
    data: [],
    hasNextPage: false
  }, // 课程列表
  courseInfo: {}, // 课程详情
  courseUpCount: 0, // 课程点赞数量
  buyInfo: {},     // 下单信息
  payInfo: {},     // 支付信息
  preOrderInfo: {},     // 订单信息
  signData: {
    sign: null,
    timeStamp: null,
    userId: null,
    userType: null
  }, // 大健康签名数据
  wxSignStatus: 0, // 微信签名状态, 0 未成功，1 成功。
  currentCourseInfo: {
    id: 123123123
  }, // 当前 live信息
  error: null, // 捕获需要反馈给客户端的错误，View层可以监听
  cashierPayStatus: 0 // 收银台支付装填 0 失败 1 成功  2取消
}, expertState, userState, freeClinicState, nimState);

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations: {
    ...mutations,
    ...nimMutations
  },
  plugins: process.env.NODE_ENV !== 'production'
    ? []
    : []
});



// WEBPACK FOOTER //
// ./src/store/index.js